import { useMemo } from 'react';
import { ProjectId } from 'api/models';
import { useProjectTasksQuery } from 'queries/task';
/**
 * Collection-backed (no Redux). Returns store-shaped tasks for a project.
 * `useTasksFromStore` / `useTasksByProjectId` delegate here.
 */ export const useTasksFromStoreRQ = (projectId, options = {})=>{
    var _options_enabled;
    const enabled = (_options_enabled = options.enabled) !== null && _options_enabled !== void 0 ? _options_enabled : true;
    // When disabled (a cheaper subtask source exists, e.g. the paginated
    // plan's per-lane map), skip the full-list fetch/subscription entirely so
    // collection writes don't re-render the consumer or re-run the remap below.
    const { data: _tasks } = useProjectTasksQuery(projectId, {
        enabled
    });
    return useMemo(()=>enabled && (_tasks === null || _tasks === void 0 ? void 0 : _tasks.map((e)=>{
            var _e_project, _e_subTasks;
            return {
                ...e,
                project: e === null || e === void 0 ? void 0 : (_e_project = e.project) === null || _e_project === void 0 ? void 0 : _e_project.projectId,
                subTasks: e === null || e === void 0 ? void 0 : (_e_subTasks = e.subTasks) === null || _e_subTasks === void 0 ? void 0 : _e_subTasks.map((x)=>x === null || x === void 0 ? void 0 : x.taskId)
            };
        })) || [], [
        enabled,
        _tasks
    ]);
};
export const useTasksFromStore = (projectId)=>useTasksFromStoreRQ(projectId);
export const useTasksByProjectId = (projectId)=>useTasksFromStoreRQ(ProjectId(projectId));
